import { ETalepTurID } from "@shared/models";

export interface ITalepler {
    talepID: number;
    talepNo: string;
    tarih: Date;
    talepTurID: ETalepTurID;
    talepTuru: string;
    talepDurumu: ITalepDurumlari[];
    talepKategorisi: string;
    talepAltKategorisi: string;
    blokNo: string;
    bolumNo: string;
    bildirenKisi: string;
    aciklama: string;
}

export interface ITalepDurumlari {
    talepDurumID: number;
    talepDurumu: string;
}

export class TaleplerFilter {
   tarih: string;
}